import { HomeSetting } from './HomeSetting';
export default HomeSetting;
